<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom" @click="showBox">
          <div class="left">{{text}}</div>
          <div class="right"><span>{{type}}</span><img src="../../../../assets/guideSystem/right_arrow.png" alt=""></div>
        </div>
      </div>
        <div class="remark">
            <div class="titleName">办理要求</div>
            <div class="notAccepted">
                <van-field
                placeholder="请输入办理要求..."
                type="textarea"
                maxlength="500"
                v-model="value"
                @input="change"
                    />
                <span class="total">{{currentTotal}}/500</span>
            </div>
        </div>
      <div class="btn">
        <div class="submit" @click="send">
          <van-button type="primary">保存</van-button>
        </div>
        <div class="save" @click="$router.go(-1)">
          返回
        </div>
      </div>
    </div>
    <van-action-sheet
        v-model="isshow"
        :actions="actions"
        description="请选择指挥中心"
        @select="onSelect"
      />
  </div>
</template>
<script>
    export default {
        data () {
            return {
                currentTotal: 0,
                value: '',
                actions: this.$store.state.complaint.type,
                selectItem: '',
                type: '请选择',
                text: '指挥中心',
                isshow: false,
                allType: this.$store.state.complaint.addType
            };
        },
        created () {
            console.log(this.allType);
        },
        methods: {

            change () {
                this.currentTotal = this.value.trim().length;
            },
            showBox () {
                this.isshow = true;
            },
            onSelect (item) {
                this.selectItem = item;
                this.type = item.name;
                this.isshow = false;
            },
            send () {
                if (this.type === '指挥中心') {
                    this.$Toast('请选择指挥中心');
                } else if (this.value.trim().length === 0) {
                    this.$Toast('请填写办理要求');
                } else {
                    if (this.allType && this.allType.length > 0) {
                        this.allType.map((item, index) => {
                            if (item.orgId == this.selectItem.orgId) {
                                this.allType.splice(index, 1);
                            }
                        })
                    }
                    // console.log(this.selectItem);
                    // console.log(this.value);
                    const obj = Object.assign({}, this.selectItem, { 'reson': this.value });
                    this.$store.commit('complaint/addType', obj);
                    this.$router.back();
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          color: #aaa;
          img {
              float: right;
              display: inline-block;
              height: 15px;
              width: 15px;
              margin-top: 17px;
          }
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 15px;
      }
        .notAccepted {
            margin-top: 14px;
            position: relative;
            .van-cell {
                font-size: 12px;
                background: #efeded;
                border-radius: 7px;
            }
            .total{
              position: absolute;
              bottom:6px;
              right:6px;
          }
        }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
   .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .save {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
          height: 44px;
          line-height: 44px;
          background-color: #f0f0f0;
          color: #9c9090;
          text-align: center;
          border-radius: 5px;
          border: solid 1px #dcdcdc
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
